import { IconTrendingDown, IconTrendingUp } from '@rossum/ui/icons/tabler';
import { Chip, SvgIcon } from '@rossum/ui/material';
import { convertRateToPercentage } from '../../core/utils';

export const DifferenceChip = ({
  difference,
  dataCy,
}: {
  difference: number;
  dataCy?: string;
}) => {
  return (
    <Chip
      size="small"
      icon={
        difference === 0 ? undefined : (
          <SvgIcon fontSize="medium">
            {difference > 0 ? (
              <IconTrendingUp data-cy="icon-trending-up" />
            ) : (
              <IconTrendingDown data-cy="icon-trending-down" />
            )}
          </SvgIcon>
        )
      }
      label={convertRateToPercentage(Math.abs(difference))}
      data-cy={dataCy}
    />
  );
};
